module.exports = __webpack_public_path__ + "static/media/Kuva_6_2.3a42ea41.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_6_2.png
// module id = 1401
// module chunks = 0